/* eslint-disable max-classes-per-file */
import { AxiosRequestConfig } from 'axios';
import { ApiMethod } from './apiMethod';

export default class RequestConfig {
  url?: string;
  type?: ApiMethod;
  baseURL?: string;
  headers?: any;
  query?: any;
  body?: any;
  skipInterceptors?: boolean;
  writeValuesToConsole?: boolean;
  // timeout?: number;
  // timeoutErrorMessage?: string;
  withCredentials?: boolean;
  // adapter?: AxiosAdapter;
  auth?: {password: string, username: string};
  responseType?: XMLHttpRequestResponseType;
  // onUploadProgress?: (progressEvent: any) => void;
  // onDownloadProgress?: (progressEvent: any) => void;
}

class RequestConfigConverter {
  toAxios(requestConfig: RequestConfig) {
    const axiosConfig = { ...requestConfig } as AxiosRequestConfig;
    if (requestConfig.body) {
      axiosConfig.data = requestConfig.body;
    }
    if (requestConfig.query) {
      axiosConfig.params = requestConfig.query;
    }
    if (requestConfig.type) {
      axiosConfig.method = requestConfig.type;
    }
    return axiosConfig;
  }
}
const requestConfigConverter = new RequestConfigConverter();
export { requestConfigConverter };
